import { render } from "./SizePicker.vue?vue&type=template&id=76c96fc3&scoped=true"
import script from "./SizePicker.vue?vue&type=script&lang=js"
export * from "./SizePicker.vue?vue&type=script&lang=js"

import "./SizePicker.vue?vue&type=style&index=0&id=76c96fc3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c96fc3"]])

export default __exports__